import instance from '../../axios';

export const createMerchants = async (data) => {
  const response = await instance.post('merchants/create', data);
  return response.data;
};

export const updateMerchants = async (data) => {
  const response = await instance.post('merchants/update', data);
  return response.data;
};

export const deleteMerchants = async (data) => {
  const response = await instance.post('merchants/delete', data);
  return response.data;
};

export const getAllMerchants = async () => {
  const response = await instance.get('merchants/get-all');
  return response.data;
};

export const getMerchantsById = async (id) => {
  const response = await instance.get(`merchants/get-by-id?id=${id}`);
  return response.data;
};
